module.exports = __webpack_public_path__ + "img/individual-2.b32fc6c.webp";